<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			class="svg-inline--fa fa-reply"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 640 640"
		>
			<path
				class="light"
				fill="currentColor"
				d="M280 224C266.7 224 256 213.3 256 200L256 112L96 272L256 432L256 344C256 330.7 266.7 320 280 320L384 320C454.7 320 512 377.3 512 448C512 456.3 511.3 464.1 510 471.2C528.2 447.8 544 414.1 544 368C544 288.5 479.5 224 400 224L280 224zM288 368L288 432C288 444.9 280.2 456.6 268.2 461.6C256.2 466.6 242.5 463.8 233.3 454.7L73.3 294.7C60.8 282.2 60.8 261.9 73.3 249.4L233.3 89.4C242.5 80.2 256.2 77.5 268.2 82.5C280.2 87.5 288 99.1 288 112L288 192L400 192C497.2 192 576 270.8 576 368C576 481.3 494.5 531.9 475.8 542.1C473.3 543.5 470.5 544 467.7 544C456.8 544 448 535.1 448 524.3C448 516.8 452.3 509.9 457.8 504.8C467.2 496 480 478.4 480 448.1C480 395.1 437 352.1 384 352.1L288 352.1L288 368.1z"
			></path>
			<path
				class="regular"
				fill="currentColor"
				d="M240 192L240 216C240 229.3 250.7 240 264 240L400 240C470.7 240 528 297.3 528 368C528 383.3 526.1 397.1 522.8 409.5C506 348.6 450.2 304 384 304L264 304C250.7 304 240 314.7 240 328L240 393.4L118.6 272L240 150.6L240 192zM320 352L384 352C437 352 480 395 480 448C480 465.3 475.8 478.5 470.5 488.2C468.9 491.1 467.2 493.7 465.5 496.1C462.9 499.6 460.2 502.5 457.8 504.7C457.3 505.2 456.8 505.6 456.4 506.1C451.6 511 448.1 517.4 448.1 524.2C448.1 535.1 456.9 543.9 467.8 543.9C470.6 543.9 473.4 543.3 475.9 542C478.5 540.6 482.2 538.5 486.7 535.5C489.4 533.7 492.4 531.7 495.6 529.3C499.3 526.6 503.2 523.5 507.3 520C537.5 494.2 576 445.9 576 367.9C576 270.7 497.2 191.9 400 191.9L288 191.9L288 111.9C288 99 280.2 87.3 268.2 82.3C256.2 77.3 242.5 80.1 233.3 89.2L73.3 249.2C60.8 261.7 60.8 282 73.3 294.5L233.3 454.5C242.5 463.7 256.2 466.4 268.2 461.4C280.2 456.4 288 444.9 288 432L288 352L320 352z"
			></path>
			<path
				class="solid"
				fill="currentColor"
				d="M268.2 82.4C280.2 87.4 288 99 288 112L288 192L400 192C497.2 192 576 270.8 576 368C576 481.3 494.5 531.9 475.8 542.1C473.3 543.5 470.5 544 467.7 544C456.8 544 448 535.1 448 524.3C448 516.8 452.3 509.9 457.8 504.8C467.2 496 480 478.4 480 448.1C480 395.1 437 352.1 384 352.1L288 352.1L288 432.1C288 445 280.2 456.7 268.2 461.7C256.2 466.7 242.5 463.9 233.3 454.8L73.3 294.8C60.8 282.3 60.8 262 73.3 249.5L233.3 89.5C242.5 80.3 256.2 77.6 268.2 82.6z"
			></path>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'ReplyIcon',
	components: { Icon },
	props,
}
</script>
